const filters = {
  LH: {
    long_haul: ['ES', 'PT', 'EU'],
    long_haul_uk: ['UK'],
    long_haul_fr: ['FR'],
  },
  INT: 'international',
};

function getRoutesCombinedFilter(routes) {
  if (!routes || !routes.length || filteringByAll(routes)) return {};

  return (routes || []).reduce((acc, { value }) => {
    return updateDataByType[getRouteFilterType(value)](acc, value);
  }, {});
}

const updateDataByType = {
  SH: (acc, val) => ({ ...acc, SH: [...(acc.SH || []), val] }),
  INT: (acc) => ({ ...acc, INT: true }),
  LH: (acc, val) => ({ ...acc, LH: [...(acc.LH || []), ...getLonghaulCountry(val)] }),
};

function getRouteFilterType(value) {
  if (isShorthaul(value)) return 'SH';
  if (isInternational(value)) return 'INT';
  return 'LH';
}

function isShorthaul(value) {
  return !filters.LH[value] && value !== filters.INT;
}

function isInternational(value) {
  return value === filters.INT;
}

function getLonghaulCountry(val) {
  return filters.LH[val];
}

function filteringByAll(routes) {
  return (routes || []).find((route) => route.value === 'all');
}

export default getRoutesCombinedFilter;
